import angular from 'angular';
import {
  pmDataService,
  loaderService,
  ssDialogService, pmSharedModelService,
} from 'app/services';

import NewSyncableBatchChangeController from './new-syncable-batch-change.controller';
import NewSyncableBatchChangeDirective from './new-syncable-batch-change.directive';

export default angular.module('app.components.advisory.policyManagement.syncBatchChange', [
  pmDataService,
  loaderService,
  ssDialogService, pmSharedModelService,
])
  .directive('newSyncableBatchChange', NewSyncableBatchChangeDirective)
  .controller('NewSyncableBatchChangeController', NewSyncableBatchChangeController)
  .name;
console.log('app.components.advisory.policyManagement.syncBatchChange');
